/*  eslint-disable react/destructuring-assignment*/

import React, { ReactElement } from "react";

import SamskipLogo from "@assets/images/samskip-logo.inline.svg";

interface LabelHeaderProps {
  postCode: string;
  type?: string;
  unNumber?: string;
}

const LabelHeader = (props: LabelHeaderProps): ReactElement => {
  return (
    <div className="flex flex-row justify-between border border-black text-black">
      <div className="p-2">
        <SamskipLogo height="50" width="310" />
      </div>
      <div className="flex justify-around font-bold text-4xl p-4 w-1/4">
        {props.unNumber && (
          <>
            <span>E</span>
            <span>/</span>
          </>
        )}
        {props.type === "FRYSTIVARA" ? (
          <>
            <span>F</span>
            <span>/</span>
          </>
        ) : props.type === "KÆLIVARA" ? (
          <>
            <span>K</span>
            <span>/</span>
          </>
        ) : null}
        <span>{props.postCode}</span>
      </div>
    </div>
  );
};

export default LabelHeader;
